import styled from 'styled-components';

// images
import LoaderSvg from 'assets/pics/icons/loader.svg';

const Loader = styled.i`
  background-image: url(${LoaderSvg});
  top: 45%;
  left: 49%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 50px;
  height: 50px;
  margin: 0 auto;
  position: absolute;
  transition: all 300ms ease-in-out;
`;

export default Loader;
